// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clock from "@insite/mobius/Icons/Clock";
import { focusedLinkStyles, linkStyles } from "@synd/App/SharedStyles/AutoCompleteSharedStyles";
import { searchHistoryStyles } from "@synd/Overrides/Widgets/Header/SearchHistory";
import LinkClearFilters from "@synd/XDL/Icons/LinkClearFilters";
import { color, createLinkIconStyles, styledScrollbar, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 16px;
        width: 507px;
        ${styledScrollbar()}
        ${xScreen("lte", "lg")} {
            width: 430px;
        }
        ${xScreen("lte", "md")} {
            margin: 0 auto;
            border-top: 1px solid ${color("common.border")};
            width: calc(100% - 32px);
            padding: 16px 0;
        }
    `,
};

searchHistoryStyles.headerText = {
    variant: "h6",
    transform: "uppercase",
    css: css`
        margin-bottom: 0;
    `,
};

searchHistoryStyles.clearLink = {
    ...createLinkIconStyles({
        icon: LinkClearFilters,
        linkStyles: {
            color: "primary",
            icon: {
                position: "right",
            },
        },
        sizeVariant: "xsmall",
    }),
};

searchHistoryStyles.topWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

searchHistoryStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 12,
    css: css`
        margin-right: 6px;
    `,
};

searchHistoryStyles.link = linkStyles;
searchHistoryStyles.focusedLink = focusedLinkStyles;
